import React from 'react';
import { LOCKED_FUNDS_INVESTED_IMAGE } from '../mockImages';

const LockedFundsInvestedSection = () => (
    <div
        className="structured-investments-table-shell structured-investments-table-shell--locked"
        aria-hidden="true"
    >
        <div className="structured-investments-table-wrapper structured-investments-table-wrapper--locked">
            <img
                src={LOCKED_FUNDS_INVESTED_IMAGE}
                alt="Locked funds invested preview"
                className="structured-investments-table__preview-image structured-investments-table__preview-image--fund-investments"
            />
        </div>
    </div>
);

export default LockedFundsInvestedSection;
